export enum OperatorDescriptionKinds {
  REPLACE = "replace",
  CLEAR = "clear",
  APPEND = "append",
  MATH_ADD = "mathAdd",
  MATH_SUBTRACT = "mathSubtract",
  MATH_MULTIPLY = "mathMultiply",
  MATH_DIVIDE = "mathDivide",
}

export enum MathOperatorDescriptionKinds {
  MATH_ADD = "mathAdd",
  MATH_SUBTRACT = "mathSubtract",
  MATH_MULTIPLY = "mathMultiply",
  MATH_DIVIDE = "mathDivide",
}
